import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { Title } from '../Title';

interface InstallationsBlockProps {
  img: string;
  title: string;
}

function InstallationsBlock({ img, title }: InstallationsBlockProps) {
  return (
    <div className='mb-1 flex flex-col items-center gap-5 rounded-3xl'>
      <div className='relative mx-auto h-48 w-8/12 overflow-hidden rounded-3xl'>
        <Image
          src={img}
          alt={`Image of ${title}`}
          fill
          className='object-cover'
        />
      </div>
      <div className='text-center font-medium text-black'>{title}</div>
    </div>
  );
}

function Installations() {
  const { t } = useTranslation();

  return (
    <div className='space-y-10'>
      <Title title={t('services:Warehouse Service.installations.title')} />
      <div className='!mt-6'>
        {t('services:Warehouse Service.installations.subtitle')}
      </div>
      <div className='grid grid-cols-1 gap-10 md:grid-cols-2 '>
        <InstallationsBlock
          img={'/outdoor1.JPEG'}
          title={t('services:Warehouse Service.outdoor')}
        />
        <InstallationsBlock
          img={'/indoor1.JPEG'}
          title={t('services:Warehouse Service.indoor')}
        />
        <InstallationsBlock
          img={'/partially.JPEG'}
          title={t('services:Warehouse Service.partial')}
        />
        <InstallationsBlock
          img={'/heated_building.JPEG'}
          title={t('services:Warehouse Service.heated')}
        />
      </div>
    </div>
  );
}

export default Installations;
